import Vue from 'vue'
import Vuex from 'vuex'
import { Hs } from '@rtidatascience/harness'

import SelectedParameterMutations from './mutations/selectedParameters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedYear: 2022,
    isLoadingYear: false,
    metadata: {},
    modules: {},
    buildingFilter: {},
    selectedRowParameters: null,
    selectedColumnParameters: null,
    selectedFilter: null
  },
  getters: {
    getQuestion: (state) => (id) => state.metadata[id],
    buildingFilter: (state) => state.buildingFilter,
    year: (state) => state.selectedYear,
    rowId: (state) => state.selectedRowParameters && state.selectedRowParameters.id,
    rowQuestion: (state) => state.selectedRowParameters != null ? state.metadata[state.selectedRowParameters.id] : null,
    filteredRowQuestion: (state) => {
      if (state.selectedRowParameters == null) {
        return null
      }

      const question = state.metadata[state.selectedRowParameters.id]
      return filterQuestionBySelection(question, state.selectedRowParameters)
    },
    columnId: (state) => state.selectedColumnParameters && state.selectedColumnParameters.id,
    columnQuestion: (state) => state.selectedColumnParameters != null ? state.metadata[state.selectedColumnParameters.id] : null,
    filteredColumnQuestion: (state) => {
      if (state.selectedColumnParameters == null) {
        return null
      }

      const question = state.metadata[state.selectedColumnParameters.id]
      return filterQuestionBySelection(question, state.selectedColumnParameters)
    },
    filterId: (state) => state.selectedFilter && state.selectedFilter.id,
    filterQuestion: (state) => state.selectedFilter != null ? state.metadata[state.selectedFilter.id] : null,
    filterByQuestion: (state) => {
      if (state.selectedFilter == null) {
        return null
      }

      const question = state.metadata[state.selectedFilter.id]
      return filterQuestionBySelection(question, state.selectedFilter)
    }
  },
  mutations: {
    ...SelectedParameterMutations,
    buildFilter (state, payload) {
      if (payload == null) {
        state.buildingFilter = null
      } else {
        const hs = new Hs('topic', this)
        state.buildingFilter = {
          id: hs.getFilter('accordion'),
          values: payload
        }
      }
    },
    setYear (state, year) {
      state.selectedYear = year
    },
    setIsLoadingYear (state, isLoading) {
      state.isLoadingYear = isLoading
    },
    setRowQuestion (state) {
      state.selectedRowParameters = state.buildingFilter
    },
    clearRowQuestion (state) {
      state.selectedRowParameters = null
    },
    setColumnQuestion (state) {
      state.selectedColumnParameters = state.buildingFilter
    },
    clearColumnQuestion (state) {
      state.selectedColumnParameters = null
    },
    setFilterQuestion (state, filter) {
      if (filter.id == null) {
        state.selectedFilter = null
      } else {
        state.selectedFilter = filter
      }
    },
    clearFilterQuestion (state) {
      state.selectedFilter = null
    },
    swapSelectedQuestions (state) {
      if (state.selectedRowParameters != null && state.selectedColumnParameters != null) {
        const temp = state.selectedRowParameters
        state.selectedRowParameters = state.selectedColumnParameters
        state.selectedColumnParameters = temp
      }
    }
  }
})

function filterQuestionBySelection (question, selection) {
  const copy = { ...question, id: selection.id }
  copy.levels = copy.levels.filter(l => selection.values.find(v => v === l.value) != null)

  return copy
}
